import {Component, Input, OnInit, ViewChild} from '@angular/core';
import AddOverlayService from './add-overlay.service';
import {NoteFormComponent} from '../note/note-form/note-form.component';
import NoteModel from '../../../model/note.model';
import DoingModel from '../../../model/doing.model';
import DoingService from '../../../api/doing/doing.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BehaviorSubject, combineLatest, forkJoin} from "rxjs";
import ArtistService from "../../../api/artist/artist.service";
import ArtistContext from "../../util/artist.context";
import ArtistModel from "../../../model/artist.model";
import CustomerService from "../../../api/customer/customer.service";
import InvoiceService from "../../../api/invoice/invoice.service";
import {debounceTime, distinctUntilChanged, skip} from "rxjs/operators";
import {Router} from "@angular/router";
import CooperationService from "../../../api/cooperation/cooperation.service";


interface SearchResult {
    title: string;
    description: string;
    image: string;
    route: string[];
    data?: any;
    type?: 'cooperation'|'artist'|'invoice'
}

@Component({
  selector: 'app-add-overlay',
  templateUrl: './add-overlay.component.html',
  styleUrls: ['./add-overlay.component.scss']
})
export class AddOverlayComponent implements OnInit {
  public visible: boolean;

  private querySubject = new BehaviorSubject<string>(null);
  public query$ = this.querySubject.asObservable();

  private resultsSubject = new BehaviorSubject<SearchResult[]>([]);
  public results$ = this.resultsSubject.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  //@ViewChild('noteForm') noteForm: NoteFormComponent;
  @ViewChild('queryInput') queryInput;
  constructor(private addOverlayService: AddOverlayService, private doingService: DoingService, private router: Router,
              private snackBar: MatSnackBar, private artistService: ArtistService, private customerService: CustomerService, private invoiceService: InvoiceService,
              private cooperationService: CooperationService) {
    this.visible = false;
  }

  ngOnInit(): void {
    this.addOverlayService.setComponent(this);

    this.query$.pipe(skip(1), debounceTime(500), distinctUntilChanged()).subscribe(query => {
      this.loadResults();
    });
  }

  close() {
    this.addOverlayService.hide();
  }

  loadResults() {
    this.loadingSubject.next(true);
    combineLatest([
        this.artistService.list(this.querySubject.getValue(), 1, 3),
        this.customerService.list(this.querySubject.getValue(), 1, 3),
        this.cooperationService.list(this.querySubject.getValue(), 1, 5),
        this.invoiceService.list(this.querySubject.getValue(), 1, 3)
    ]).subscribe(data => {
      let results = [] as SearchResult[];

      for (const artist of data[0].results) {
          results.push({
            title: artist.name,
            description: 'Artist',
            image: (artist.profileImage ? artist.profileImage.filename : null),
            route: ['/artists', '' + artist.id],
            data: artist,
            type: 'artist'
          });
      }
      for (const customer of data[1].results) {
        results.push({
          title: customer.companyDisplayName,
          description: customer.companyName,
          route: ['/companies', '' + customer.id],
          image: (customer.logo ? customer.logo.filename : '')
        });
      }
      for (const coop of data[2].results) {
        results.push({
          title: coop.name,
          description: 'Kooperation zwischen ' + coop.artist.name + ' und ' + coop.customer.companyDisplayName,
          route: ['/cooperations', '' + coop.id],
          image: (coop.customer.logo ? coop.customer.logo.filename : ''),
          data: coop,
          type: 'cooperation'
        });
      }
      for(const invoice of data[3].results) {
        results.push({
          title: invoice.reference,
          description: invoice.fromName,
          image: null,
          route: ['/invoices', '' + invoice.id],
          data: invoice,
          type: 'invoice'
        });
      }

      this.resultsSubject.next(results);
      this.loadingSubject.next(false);
    }, error => {
      this.loadingSubject.next(false);
    });
  }

  show() {

    this.visible = true;
    setTimeout(() => {
      this.queryInput.nativeElement.focus();
      this.queryInput.nativeElement.value = '';
      //this.noteForm.focus();
    }, 50);
  }

  updateQuery(query) {
    this.querySubject.next(query);
  }

  resultClicked(result: SearchResult) {
    this.queryInput.nativeElement.value = '';
    this.router.navigate(result.route);
    this.addOverlayService.hide();
  }

  clickFirstResult() {
    if(this.resultsSubject.getValue().length > 0) {
      this.resultClicked(this.resultsSubject.getValue()[0]);
    }
  }
  addDoing(note: NoteModel) {
    /*let doing = {
      text: note.text,
      marked_user: note.marked_user
    } as DoingModel;

    this.doingService.create(doing).subscribe(result => {
      this.snackBar.open('Doing hinzugefügt');
      this.close();
    });*/
  }
}
